// Only absolute web links are supported by the CRM content fields.
export const parseHttpUrl = (value) => {
    if (typeof value !== "string" || !/^https?:\/\//i.test(value.trim())) return null;
    if (Array.from(value).some(character => (
        character === "\\" || character.charCodeAt(0) < 32 || character.charCodeAt(0) === 127
    ))) return null;

    try {
        const url = new URL(value.trim());
        return ["http:", "https:"].includes(url.protocol) && !url.username && !url.password
            ? url : null;
    } catch (_) {
        return null;
    }
};
